import React, {Component, useRef} from 'react'
//redux
import { connect } from "react-redux";
import { getUserInfoData } from "../../common/User/store/actionCreators";
//样式
import {
    Container
} from "./style";

//组件
import { ImageUploader, Space, Toast, Dialog } from 'antd-mobile'
import {FileItem } from 'antd-mobile/es/components/image-uploader'
import $axios from "../../request";




class ImgUpload extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imgList:[],
            imgMaxCount:6,
        }
    }

    componentDidMount() {
        // this.props._getUserInfoData();
        // this.getDetail();
        let newList = []
        this.props.imgList.map((item, index) => {
            newList.push({
                url: item
            })
        })


        this.setState({
            imgList: newList
        });
        if(this.props.imgMaxCount){
            this.setState({
                imgMaxCount: this.props.imgMaxCount
            });
        }

    }


    onImgChange=async(imgList)=>{

        console.log("onImgChange",imgList)

       this.setState({imgList:imgList});
        let newListCallback = []
        imgList.map((item, index) => {
            newListCallback.push(item.url)
        })
        this.props.parent(newListCallback)
    }
     onUpload=async(file:File)=>{
        console.log("mockUpload",file)

         let response1 = '';
       await $axios.uploadRequest('/shop/upload', file)
            .then((response) => {
                if (response && response.succeed) {
                    response1= response;
                }
            });

         return{
                 url: $axios.imgUrl+response1.data.url,
               }

    }

     beforeUpload=async(files: File[])=> {
        return files.filter(file => {
            // if (file.size <= 1024 * 1024*2) {
            //     Toast.show('请选择大于 2M 的图片')
            //     return false
            // }
            if (file.size > 1024 * 1024*100) {
                Toast.show('请选择小于 100M 的图片')
                return false
            }
            if(!(file.type.includes('png')
                ||file.type.includes('jpg')
                ||file.type.includes('jpeg'))){
                Toast.show(`只允许上传图片`);
                return false;
            }
            return true
        })
    }




    render() {
        let { imgList,imgMaxCount } = this.state
        let { userInfo} = this.props;

        return (
            <Container>
                <div className="container">
                    <ImageUploader
                        value={imgList}
                        onChange={this.onImgChange}
                        upload={this.onUpload}
                        accept={'image/*'}
                        multiple
                        deletable
                        maxCount={imgMaxCount}
                        showUpload={imgList.length < imgMaxCount}
                        beforeUpload={this.beforeUpload}
                        onCountExceed={exceed => {
                            Toast.show(`最多选择 ${imgMaxCount} 张图片，你多选了 ${exceed} 张`)
                        }}
                        onDelete={() => {
                            return Dialog.confirm({
                                content: '是否确认删除',
                            })
                        }}
                    />
                </div>


            </Container>
        )
    }
}

const mapState = state => {

    console.log('userInfo',state.getIn(['user', 'userInfo']));
    return {
        userInfo:state.getIn(['user', 'userInfo'])
    }

}
const mapDispatch = dispatch => {
    return {

        _getUserInfoData(data) {

            dispatch(getUserInfoData(data))
        }
    }
}

export default connect(mapState, mapDispatch)(ImgUpload)
